import { CIURMA_URL } from "@/lib/links";

// Stesso protocollo del ricevitore in ciurma.lumacofono.com: #trasferisci= + base64(JSON {best, history, player})
const GAME_KEYS = { best: "ctlc-best-island", history: "ctlc-history", player: "ctlc-player" };
const PREFIX = "#trasferisci=";
let pending = null;

const localPayload = () => {
  try {
    const d = Object.fromEntries(Object.entries(GAME_KEYS).map(([k, key]) => [k, localStorage.getItem(key)]));
    return Object.values(d).some((v) => v !== null) ? encodeURIComponent(btoa(JSON.stringify(d))) : null;
  } catch {
    return null;
  }
};

export function handleLegacyUrls() {
  const { pathname, search, hash } = window.location;
  if (hash.startsWith(PREFIX)) {
    pending = hash.slice(PREFIX.length);
    window.history.replaceState(null, "", pathname + search);
  }
  const params = new URLSearchParams(search);
  if (pathname === "/" && (params.has("sfida") || params.has("classifica"))) {
    const p = pending || localPayload();
    window.location.replace(`${CIURMA_URL}/${search}${p ? PREFIX + p : ""}`);
    return true;
  }
  return false;
}
